module.exports = __webpack_public_path__ + "static/media/visibilitat-04.4221f7f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/visibilitat/visibilitat-04.svg
// module id = 784
// module chunks = 0